import { defineMessages } from 'react-intl';

const messages = defineMessages({
  verify: {
    id: 'common.verify',
    description: 'verify',
    defaultMessage: '인증'
  },
  signin: {
    id: 'common.signin',
    description: 'signin',
    defaultMessage: '로그인'
  },
  signup: {
    id: 'common.signup',
    description: 'signup',
    defaultMessage: '회원가입'
  },
  signout: {
    id: 'common.signout',
    description: 'signout',
    defaultMessage: '로그아웃'
  },
  or: {
    id: 'common.or',
    description: 'or',
    defaultMessage: '또는'
  },
  today: {
    id: 'common.today',
    description: 'today',
    defaultMessage: '오늘'
  },
  clear: {
    id: 'common.clear',
    description: 'clear',
    defaultMessage: '초기화'
  },
  email: {
    id: 'common.email',
    description: 'email',
    defaultMessage: '이메일'
  },
  phone: {
    id: 'common.phone',
    description: 'phone',
    defaultMessage: '전화번호'
  },
  password: {
    id: 'common.password',
    description: 'password',
    defaultMessage: '비밀번호'
  },
  username: {
    id: 'common.username',
    description: 'username',
    defaultMessage: '닉네임'
  },
  firstName: {
    id: 'common.firstName',
    description: 'firstName',
    defaultMessage: '이름'
  },
  lastName: {
    id: 'common.lastName',
    description: 'lastName',
    defaultMessage: '성'
  },
  cancel: {
    id: 'common.cancel',
    description: 'cancel',
    defaultMessage: '취소'
  },
  ok: {
    id: 'common.ok',
    description: 'ok',
    defaultMessage: '확인'
  },
  yes: {
    id: 'common.yes',
    description: 'yes',
    defaultMessage: '예'
  },
  confirm: {
    id: 'common.confirm',
    description: 'confirm',
    defaultMessage: '확인'
  },
  upload: {
    id: 'common.upload',
    description: 'upload',
    defaultMessage: '업로드'
  },
  name: {
    id: 'common.name',
    description: 'name',
    defaultMessage: '이름'
  },
  save: {
    id: 'common.save',
    description: 'save',
    defaultMessage: '저장'
  },
  delete: {
    id: 'common.delete',
    description: 'delete',
    defaultMessage: '삭제'
  },
  copy: {
    id: 'common.copy',
    description: 'copy',
    defaultMessage: '복제'
  },
  period: {
    id: 'common.period',
    description: 'period',
    defaultMessage: '기간'
  },
  day: {
    id: 'common.day',
    description: 'day',
    defaultMessage: '일'
  },

  factor: {
    id: 'common.factor',
    description: 'factor',
    defaultMessage: '지표'
  },
  operation: {
    id: 'common.operation',
    description: 'operation',
    defaultMessage: '조건'
  },
  value: {
    id: 'common.value',
    description: 'value',
    defaultMessage: '값'
  },
  conditionalCombineType: {
    id: 'common.conditionalCombineType',
    description: 'Conditional combination condition',
    defaultMessage: '조건식 조합 조건'
  },
  ascending: {
    id: 'common.ascending',
    description: 'ascending',
    defaultMessage: '오름차순'
  },
  descending: {
    id: 'common.descending',
    description: 'descending',
    defaultMessage: '내림차순'
  },

  deleteWarnTitle: {
    id: 'common.deleteWarnTitle',
    defaultMessage: '삭제 하시겠습니까?',
    description: 'Delete warn dialog title'
  },
  quantastic: {
    id: 'common.quantastic',
    defaultMessage: '퀀타스틱',
    description: 'quantastic'
  }
});

export default messages;
